

import { useEffect } from "react";
import { useProgress } from "../../context/ProgressContext";
import BookmarkButton from "../../components/BookmarkButton";
import SectionCompleteBar from "../../components/SectionCompleteBar";
import MultipleIntegralsGuide from "./MultipleIntegralsGuide";
import "./GuidePart.css";

function IntegralsPart1() {
  const { recordVisit } = useProgress();

  useEffect(() => {
    recordVisit("integrals-1");
  }, [recordVisit]);

  return (
    <div className="guide-part-wrapper">
      <div className="guide-part-topbar">
        <div className="guide-part-info">
          <span className="guide-part-badge">Section 1</span>
          <span className="guide-part-title">
            Multiple Integrals — Double Integrals & Fubini's Theorem
          </span>
        </div>
        <BookmarkButton
          id="integrals-1"
          title="Multiple Integrals — Section 1"
          path="/multiple-integrals/1"
        />
      </div>
      <MultipleIntegralsGuide part={1} />
      <SectionCompleteBar
        sectionId="integrals-1"
        nextPath="/multiple-integrals/2"
        nextLabel="Triple Integrals & Coordinates"
      />
    </div>
  );
}

export default IntegralsPart1;